import { render, staticRenderFns } from "./content2.vue?vue&type=template&id=52f73880&scoped=true"
import script from "./content2.vue?vue&type=script&lang=js"
export * from "./content2.vue?vue&type=script&lang=js"
import style0 from "./content2.vue?vue&type=style&index=0&id=52f73880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f73880",
  null
  
)

export default component.exports